import { render, staticRenderFns } from "./WelcomeOverlay.vue?vue&type=template&id=407cd22d&scoped=true&"
import script from "./WelcomeOverlay.vue?vue&type=script&lang=js&"
export * from "./WelcomeOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeOverlay.vue?vue&type=style&index=0&id=407cd22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cd22d",
  null
  
)

export default component.exports